














import { Component, Vue } from 'vue-property-decorator';
import UnsupportViewPcQrcode from '@/components/UnsupportViewPcQrcode.vue';
import UnsupportViewRedirect from '@/components/UnsupportViewRedirect.vue';
import UnsupportViewPcBrowser from '@/components/UnsupportViewPcBrowser.vue';
import UnsupportView from '@/components/UnsupportView.vue';

@Component({
  components: {
    UnsupportViewPcQrcode,
    UnsupportViewRedirect,
    UnsupportViewPcBrowser,
    UnsupportView
  }
})
export default class Parts extends Vue {
  private get isSupport(): boolean {
    if (!this.$store.getters['support/isReady']) return true;
    return this.$store.getters['support/isSupport'];
  }

  private get isPcUnsupport(): boolean {
    return this.$store.getters['camera/isPC'] && !this.$store.getters['auth/kycOrgConfigEnableClientTypePC'];
  }

  private get isUseErrorRedirectURL(): boolean {
    return this.$store.getters['auth/kycOrgConfig'].useErrorRedirectURL;
  }

  private get isOwnErrorRedirectURL(): boolean {
    return this.$store.getters['auth/kycRequestErrorRedirectURL'];
  }

  private get isPcBrowser(): boolean {
    return this.$store.getters['camera/isPC'] && !this.$store.getters['support/isBrowser'];
  }
}
